import { render, staticRenderFns } from "./DonationPF.vue?vue&type=template&id=08727921&scoped=true&"
import script from "./DonationPF.vue?vue&type=script&lang=js&"
export * from "./DonationPF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08727921",
  null
  
)

export default component.exports